module.exports = "/api/cdn/public/static-assets/images/dec3b0138e045c5ed6158e4024a58c50.png";